module.exports = __webpack_public_path__ + "Flag-120.34c2bd76faa66d71c87e852eab8ed56f.svg";